"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _app = require("@package/app");

var _numeral = _interopRequireDefault(require("@package/numeral"));

var _utils = require("@package/utils");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Paging(_ref) {
  var formState = _ref.formState,
      change = _ref.change,
      submit = _ref.submit,
      dispatch = _ref.dispatch;

  try {
    var handlePrevClick = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
        var page, newPage;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = formState.page;
                newPage = page - 1;

                if (!(newPage > 0)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return dispatch(change('page', newPage));

              case 5:
                submit('paging-form');

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handlePrevClick() {
        return _ref2.apply(this, arguments);
      };
    }();

    var handleNextClick = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
        var page, pages, newPage;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                page = formState.page, pages = formState.pages;
                newPage = page + 1;

                if (!(newPage <= pages)) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 5;
                return dispatch(change('page', newPage));

              case 5:
                submit('paging-form');

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function handleNextClick() {
        return _ref3.apply(this, arguments);
      };
    }();

    var page = formState.page,
        pages = formState.pages,
        totalRow = formState.totalRow;
    var isDisabledPrev = page === 1;
    var isDisabledNext = page === pages;
    var prevButtonClassName = (0, _classnames["default"])(_defaultModule["default"]['paging__button'], _defaultModule["default"]['paging__button--prev'], 'icon-arrow-left', (0, _defineProperty2["default"])({}, _defaultModule["default"]['paging__button--disabled'], isDisabledPrev));
    var nextButtonClassName = (0, _classnames["default"])(_defaultModule["default"]['paging__button'], _defaultModule["default"]['paging__button--next'], 'icon-arrow-right', (0, _defineProperty2["default"])({}, _defaultModule["default"]['paging__button--disabled'], isDisabledNext));
    return pages > 1 && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['paging'],
      "data-locator": "paging"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['description']
    }, (0, _utils.nounDeclension)(totalRow, ['Показан', 'Показано', 'Показано']), " ", (0, _numeral["default"])(totalRow).format('0,00'), " ", (0, _utils.nounDeclension)(totalRow, ['результат', 'результата', 'результатов'])), /*#__PURE__*/_react["default"].createElement("button", {
      className: prevButtonClassName,
      disabled: isDisabledPrev,
      onClick: function onClick() {
        return handlePrevClick();
      },
      "data-locator": "paging.prev"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['numbers']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['number'],
      "data-locator": "paging.page"
    }, page), /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['separator']
    }, "\u0438\u0437"), /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['number'],
      "data-locator": "paging.pages"
    }, pages)), /*#__PURE__*/_react["default"].createElement("button", {
      className: nextButtonClassName,
      disabled: isDisabledNext,
      onClick: function onClick() {
        return handleNextClick();
      },
      "data-locator": "paging.next"
    }));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Paging;
exports["default"] = _default;